import React from "react";
import { Grid } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";

import { useSelector } from "react-redux";
import { FormReclamOEfector } from "./FormReclamOEfector";

export const ReclamosDatosFormEfector = (props) => {

    const { formValues, handleInputChange } = props;
    const { dataEfector } = useSelector((state) => state.reclamos);

  return (
    <Grid container spacing={1}>
    <FormReclamOEfector
      formValues={formValues}
      handleInputChange={handleInputChange}
      setearValor={props.setearValor}
      setearValores={props.setearValores}
      setearVariosValores={props.setearVariosValores}
      dataEfector={dataEfector}
    />
    <Grid item xs={12}>
      <TextValidator
        multiline
        rows={5}
        fullWidth
        variant="outlined"
        margin="normal"
        label="Descripción"
        name="descripcion"
        value={formValues.descripcion}
        onChange={handleInputChange}
        validators={["required"]}
        errorMessages={["Este campo es obligatorio"]}
        InputLabelProps={{ style: { fontWeight: "bold" } }}
      />
    </Grid>
  </Grid>
  )
}
